module.exports = __webpack_public_path__ + "img/mobilehardwareOpen2.dba94031.png";